import Vue from 'vue'
import VueRouter from 'vue-router'
import Test from '../components/Test.vue'
import Login from '../components/auth/Login.vue'
import Logout from '../components/auth/Logout.vue'
import SetPassword from '../components/auth/SetPassword.vue'
import Index from '../components/Index.vue'
import PrEntry from '../components/pr/Entry.vue'
import PrList from '../components/pr/List.vue'
import PoEntry from '../components/po/Entry.vue'
import PoList from '../components/po/List.vue'
import MmEntry from '../components/mm/Entry.vue'
import MmList from '../components/mm/List.vue'
import ToBeDone from '../components/ToBeDone.vue'
import RouterThru from '../components/RouterThru.vue'
import Drr from '../components/drr/Drr.vue'
import Prr from '../components/drr/Prr.vue'
import DrrInput from '../components/drr/Input.vue'
import DrrStorno from '../components/drr/Storno.vue'
import PlMonth from '../components/pl/reports/PlMonth.vue'
import PlMonthFcst from '../components/pl/reports/PlMonthFcst.vue'
import PlThreeMonths from '../components/pl/reports/PlThreeMonths.vue'
import PlTwelveMonths from '../components/pl/reports/PlTwelveMonths.vue'
import PlQuarter from '../components/pl/reports/PlQuarter.vue'
import PlFourQuarters from '../components/pl/reports/PlFourQuarters.vue'
import PlYearBudget from '../components/pl/reports/PlYearBudget.vue'
// import PlBi from '../components/pl/Bi.vue'
import PlApproval from '../components/pl/Approval.vue'
import PlInputCsv from '../components/pl/input/Csv.vue'
import PlInputRooms from '../components/pl/input/Rooms.vue'
import PlInputFb from '../components/pl/input/Fb.vue'
import PlInputHr from '../components/pl/input/Hr.vue'
import PlInputUtilities from '../components/pl/input/Utilities.vue'
import PlInputStaffDining from '../components/pl/input/StaffDining.vue'
import PlInputLaundry from '../components/pl/input/Laundry.vue'
import PlForecast from '../components/pl/Forecast.vue'
import PlBudgetList from '../components/pl/budget/List.vue'
import PlBudgetEntry from '../components/pl/budget/Entry.vue'
import Users from '../components/users/Users.vue'
import Preferences from '../components/pref/Preferences.vue'
import HotelParameters from '../components/pref/HotelParameters.vue'
import ExpenseGuide from '../components/expenseguide/Guide.vue'
import ExpenseGuideSearchHistory from '../components/expenseguide/SearchHistory.vue'
import Help from '../components/help/Help.vue'
import PlReserves from '../components/reserves/ResAddCor.vue'
import LogsApi from '../components/logs/Api.vue'
import LogsAction from '../components/logs/Action.vue'
import LogsMail from '../components/logs/Mail.vue'
import LogsReport from '../components/logs/Report.vue'
import LogsCron from '../components/logs/Cron.vue'
import SurveyCollect from '../components/surveys/Collect.vue'
import AdminPanel from '../components/admin/Panel.vue'
import TestPanel from '../components/admin/Test.vue'
import {store} from '../lib/store'

Vue.use(VueRouter)

let origin = window.location.origin
let prefixTitle = ''
let debug = false

if (origin == 'http://localhost:8080') {
	prefixTitle = 'LOC '
}
else if (new RegExp('https?:\/\/dev-reports.ifk-hm.(com|ru)').test(origin)) {
	prefixTitle = 'DEV '
}

const routes = [

	// requiredRights: [[ 'a', 'b' ], [ 'c', 'd' ]]
	// <=>
	// (a && b) || (c && d)

	// Test Page
	{
		name: 'Test',
		path: '/test',
		component: Test,
		meta: {
			title: prefixTitle + 'Test',
			mainMenu: false,
			userMenu: false,
			requiredLogin: true,
			requiredRights: [[]]
		}
	},
	// Index
	{
		name: 'Index',
		path: '/',
		component: Index,
		meta: {
			title: prefixTitle + 'IFK Reports',
			mainMenu: false,
			userMenu: false,
			requiredLogin: true,
			requiredRights: [[]]
		}
	},
	// Preferences
	{
		name: 'Preferences',
		path: '/pref',
		component: Preferences,
		meta: {
			title: prefixTitle + 'Preferences',
			mainMenu: false,
			userMenu: true,
			name: 'Настройки',
			requiredLogin: true,
			requiredRights: [[]]
		}
	},
	// HotelParameters
	{
		name: 'HotelParameters',
		path: '/hotel',
		component: HotelParameters,
		meta: {
			title: prefixTitle + 'Hotel parameters',
			mainMenu: false,
			userMenu: true,
			name: 'Параметры отеля',
			requiredLogin: true,
			requiredRights: [[ 'hotel_parameters_edit' ]]
		}
	},
	// PrList, PrEntry
	{
		name: 'PrList',
		path: '/pr',
		component: PrList,
		meta: {
			title: prefixTitle + 'IFK Reports / PR',
			mainMenu: true,
			userMenu: false,
			name: 'Заявки на расходы',
			icon: 'shopping_basket',
			requiredLogin: true,
			requiredRights: [[ 'pr_view' ]],
			count: 0
		}
	},
	{
		name: 'PrEntry',
		path: '/pr/:id',
		component: PrEntry,
		meta: {
			title: prefixTitle + 'PR :id',
			mainMenu: false,
			userMenu: false,
			requiredLogin: true,
			requiredRights: [[ 'pr_view' ]]
		}
	},
	// PoList, PoEntry
	{
		name: 'PoList',
		path: '/po',
		component: PoList,
		meta: {
			title: prefixTitle + 'IFK Reports / PO',
			mainMenu: true,
			userMenu: false,
			name: 'Ордера на оплату',
			icon: 'credit_card',
			requiredLogin: true,
			requiredRights: [[ 'po_view' ]],
			count: 0
		}
	},
	{
		name: 'PoEntry',
		path: '/po/:id',
		component: PoEntry,
		meta: {
			title: prefixTitle + 'PO :id',
			mainMenu: false,
			userMenu: false,
			requiredLogin: true,
			requiredRights: [[ 'po_view' ]]
		}
	},
	// MmList, MmEntry
	{
		name: 'MmList',
		path: '/mm',
		component: MmList,
		meta: {
			title: prefixTitle + 'IFK Reports / MM',
			mainMenu: true,
			userMenu: false,
			name: 'Ведомости мини-макс',
			icon: 'list_alt',
			requiredLogin: true,
			requiredRights: [[ 'mm_view' ]],
			count: 0
		}
	},
	{
		name: 'MmEntry',
		path: '/mm/:id',
		component: MmEntry,
		meta: {
			title: prefixTitle + 'MM :id',
			mainMenu: false,
			userMenu: false,
			requiredLogin: true,
			requiredRights: [[ 'mm_view' ]]
		}
	},
	// Drr
	{
		name: 'Drr',
		path: '/drr',
		component: RouterThru,
		meta: {
			title: prefixTitle + 'IFK Reports / DRR',
			mainMenu: true,
			userMenu: false,
			name: 'DRR Отчеты',
			// icon: 'today',
			requiredLogin: true,
	        requiredRights: [[ 'drr_data_view' ]]
	    },
		children: [
			{
				name: 'DrrDay',
				path: 'daily',
				component: Drr,
				meta: {
					title: prefixTitle + 'IFK Reports / DRR',
					mainMenu: true,
					userMenu: false,
					name: 'Отчет за день',
					requiredLogin: true,
			        requiredRights: [[ 'drr_data_view' ]]
			    }
			},
			{
				name: 'DrrPeriod',
				path: 'period',
				component: Prr,
				meta: {
					title: prefixTitle + 'IFK Reports / PRR',
					mainMenu: true,
					userMenu: false,
					name: 'Отчет за период',
					requiredLogin: true,
			        requiredRights: [[ 'drr_data_view' ]]
			    }
			}
		]
	},
	// DrrInput, DrrStorno
	{
		name: 'DrrInput',
		path: '/drr/input',
		component: DrrInput,
		meta: {
			title: prefixTitle + 'DRR Input',
			mainMenu: true,
			userMenu: false,
			name: 'DRR Ввод данных',
			// icon: 'keyboard',
			requiredLogin: true,
	        requiredRights: [[ 'drr_input' ]]
	    },
	},
	{
		name: 'DrrStorno',
		path: '/drr/storno',
		component: DrrStorno,
		meta: {
			title: prefixTitle + 'DRR Storno',
			mainMenu: true,
			userMenu: false,
			name: 'DRR Сторно',
			// icon: 'undo',
			requiredLogin: true,
	        requiredRights: [[ 'drr_storno' ]]
	    },
	},
	// Pl
	{
		name: 'Pl',
		path: '/pl',
		component: RouterThru,
		meta: {
			title: prefixTitle + 'IFK Reports / PL',
			mainMenu: true,
			userMenu: false,
			name: 'P&L Отчеты',
			// icon: 'date_range',
			requiredLogin: true,
	        requiredRights: [[ 'pl_data_view' ]]
	    },
		children: [
			{
				name: 'PlMonth',
				path: 'month',
				component: PlMonth,
				meta: {
					title: prefixTitle + 'IFK Reports / PL',
					mainMenu: true,
					userMenu: false,
					name: 'Отчет за месяц',
					requiredLogin: true,
			        requiredRights: [[ 'pl_data_view' ]]
			    }
			},
			{
				name: 'PlMonthFcst',
				path: 'fcst',
				component: PlMonthFcst,
				meta: {
					title: prefixTitle + 'IFK Reports / PL',
					mainMenu: true,
					userMenu: false,
					name: 'Прогноз на месяц',
					requiredLogin: true,
			        requiredRights: [[ 'pl_data_view' ]]
			    }
			},
			{
				name: 'PlThreeMonths',
				path: 'threemonths',
				component: PlThreeMonths,
				meta: {
					title: prefixTitle + 'IFK Reports / PL',
					mainMenu: true,
					userMenu: false,
					name: 'Отчет за 3 месяца',
					requiredLogin: true,
			        requiredRights: [[ 'pl_data_view' ]]
			    }
			},
			{
				name: 'PlTwelveMonths',
				path: 'twelvemonths',
				component: PlTwelveMonths,
				meta: {
					title: prefixTitle + 'IFK Reports / PL',
					mainMenu: true,
					userMenu: false,
					name: 'Отчет за 12 месяцев',
					requiredLogin: true,
			        requiredRights: [[ 'pl_data_view' ]]
			    }
			},
			{
				name: 'PlQuarter',
				path: 'quarter',
				component: PlQuarter,
				meta: {
					title: prefixTitle + 'IFK Reports / PL',
					mainMenu: true,
					userMenu: false,
					name: 'Отчет за квартал',
					requiredLogin: true,
			        requiredRights: [[ 'pl_data_view' ]]
			    }
			},
			{
				name: 'PlFourQuarters',
				path: 'fourquarters',
				component: PlFourQuarters,
				meta: {
					title: prefixTitle + 'IFK Reports / PL',
					mainMenu: true,
					userMenu: false,
					name: 'Отчет за 4 квартала',
					requiredLogin: true,
			        requiredRights: [[ 'pl_data_view' ]]
			    }
			},
			{
				name: 'PlYearBudget',
				path: 'yearbudget',
				component: PlYearBudget,
				meta: {
					title: prefixTitle + 'IFK Reports / PL',
					mainMenu: true,
					userMenu: false,
					name: 'Годовой бюджет',
					requiredLogin: true,
			        requiredRights: [[ 'pl_data_view' ]]
			    }
			},
		]
	},
	// Bi
	// {
	// 	name: 'Bi',
	// 	path: '/bi',
	// 	component: PlBi,
	// 	meta: {
	// 		title: prefixTitle + 'IFK Reports / BI',
	// 		mainMenu: true,
	// 		userMenu: false,
	// 		name: 'P&L BI',
	// 		icon: 'insert_chart_outlined',
	// 		requiredLogin: true,
	//         requiredRights: [[ 'pl_data_view_all' ]]
	//     },
	// },
	// PlInput
	{
		name: 'PlInput',
		path: '/pl/input',
		component: RouterThru,
		meta: {
			title: prefixTitle + 'IFK Reports',
			mainMenu: true,
			userMenu: false,
			name: 'P&L Ввод данных',
			// icon: 'input',
			requiredLogin: true,
	        requiredRights: [
				[ 'pl_input' ],
				[ 'pl_input_rooms' ],
				[ 'pl_input_fb' ],
				[ 'pl_input_hr' ],
				[ 'pl_input_utilities' ],
				[ 'pl_input_laundry' ],
				[ 'pl_input_sd' ],
				[ 'pl_bud_direct_input' ],
				[ 'pl_direct_input' ],
			],
		},
		children: [
			{
				name: 'PlInputCsv',
				path: 'csv',
				component: PlInputCsv,
				meta: {
					title: prefixTitle + 'IFK Reports / CSV Import',
					mainMenu: true,
					userMenu: false,
					name: 'Импорт CSV данных',
					requiredLogin: true,
			        requiredRights: [[ 'pl_input' ]]
			    }
			},
			{
				name: 'PlInputRooms',
				path: 'rooms',
				component: PlInputRooms,
				meta: {
					title: prefixTitle + 'IFK Reports / Rooms data',
					mainMenu: true,
					userMenu: false,
					name: 'Показатели номерного фонда',
					requiredLogin: true,
			        requiredRights: [[ 'pl_input' ], [ 'pl_input_rooms' ]]
			    }
			},
			{
				name: 'PlInputFb',
				path: 'fb',
				component: PlInputFb,
				meta: {
					title: prefixTitle + 'IFK Reports / F&B data',
					mainMenu: true,
					userMenu: false,
					name: 'Показатели службы питания',
					requiredLogin: true,
			        requiredRights: [[ 'pl_input' ], [ 'pl_input_fb' ]]
			    }
			},
			{
				name: 'PlInputHr',
				path: 'hr',
				component: PlInputHr,
				meta: {
					title: prefixTitle + 'IFK Reports / HR data',
					mainMenu: true,
					userMenu: false,
					name: 'Показатели отдела персонала',
					requiredLogin: true,
			        requiredRights: [[ 'pl_input' ], [ 'pl_input_hr' ]]
			    }
			},
			{
				name: 'PlInputUtilities',
				path: 'ut',
				component: PlInputUtilities,
				meta: {
					title: prefixTitle + 'IFK Reports / Utilities data',
					mainMenu: true,
					userMenu: false,
					name: 'Показатели коммунальных услуг',
					requiredLogin: true,
			        requiredRights: [[ 'pl_input' ], [ 'pl_input_utilities' ]]
			    }
			},
			{
				name: 'PlInputLaundry',
				path: 'hl',
				component: PlInputLaundry,
				meta: {
					title: prefixTitle + 'IFK Reports / Laundry data',
					mainMenu: true,
					userMenu: false,
					name: 'Показатели прачечной',
					requiredLogin: true,
			        requiredRights: [[ 'pl_input' ], [ 'pl_input_laundry' ]]
			    }
			},
			{
				name: 'PlInputStaffDining',
				path: 'sd',
				component: PlInputStaffDining,
				meta: {
					title: prefixTitle + 'IFK Reports / Staff dining data',
					mainMenu: true,
					userMenu: false,
					name: 'Показатели служебной столовой',
					requiredLogin: true,
			        requiredRights: [[ 'pl_input' ], [ 'pl_input_sd' ]]
			    }
			},
		]
	},
	// PlApproval
	{
		name: 'PlApproval',
		path: '/pl/approval',
		component: PlApproval,
		meta: {
			title: prefixTitle + 'IFK Reports / PL Approvals',
			mainMenu: true,
			userMenu: false,
			name: 'P&L Согласование',
			icon: 'done_all',
			requiredLogin: true,
	        requiredRights: [
				[ 'pl_approve' ],
				[ 'pl_input' ]
			]
	    },
	},
	// PlReserves
	{
		name: 'PlReserves',
		path: '/reserves',
		component: PlReserves,
		meta: {
			title: prefixTitle + 'IFK Reports / PL Reserves',
			mainMenu: true,
			userMenu: false,
			name: 'P&L Резервы',
			// icon: 'menu_open',
			requiredLogin: true,
	        requiredRights: [[ 'pl_input' ]]
	    },
	},
	// PlForecast
	{
		name: 'PlForecast',
		path: '/forecast',
		component: PlForecast,
		meta: {
			title: prefixTitle + 'IFK Reports / PL Forecast',
			mainMenu: true,
			userMenu: false,
			name: 'P&L Прогноз',
			// icon: 'location_searching',
			requiredLogin: true,
	        requiredRights: [[ 'pl_input' ]]
	    },
	},
	// PlBudgets
	{
		name: 'PlBudgetList',
		path: '/budget/list',
		component: PlBudgetList,
		meta: {
			title: prefixTitle + 'IFK Reports / PL Budgets',
			mainMenu: true,
			userMenu: false,
			name: 'P&L Бюджеты',
			// icon: 'work_outline',
			requiredLogin: true,
	        requiredRights: [
				[ 'pl_approve' ],
				[ 'pl_input' ]
			]
	    },
	},
	{
		name: 'PlBudgetEntry',
		path: '/budget/:id',
		component: PlBudgetEntry,
		meta: {
			title: prefixTitle + 'IFK Reports / PL Budget',
			mainMenu: false,
			userMenu: false,
			requiredLogin: true,
	        requiredRights: [
				[ 'pl_approve' ],
				[ 'pl_input' ]
			]
	    },
	},
	// Users
	{
		name: 'Users',
		path: '/users',
		component: Users,
		meta: {
			title: prefixTitle + 'IFK Reports / Users',
			mainMenu: true,
			userMenu: false,
			name: 'Пользователи',
			icon: 'people_outline',
			requiredLogin: true,
	        requiredRights: [[ 'user_mgmt' ], [ 'hotel_user_mgmt' ]]
	    }
	},
	// Expense Guide
	{
		name: 'ExpenseGuide',
		path: '/expenses/',
		component: ExpenseGuide,
		meta: {
			title: prefixTitle + 'IFK Reports / Expense Guide',
			mainMenu: true,
			userMenu: false,
			name: 'Справочник расходов',
			// icon: 'chrome_reader_mode',
			requiredLogin: true,
	        requiredRights: [[ 'pl_expense_guide_view' ]]
	    }
	},
	{
		name: 'ExpenseGuideTemplate',
		path: '/expenses/:search',
		component: ExpenseGuide,
		meta: {
			title: prefixTitle + 'Expense Guide: :search',
			mainMenu: false,
			userMenu: false,
			name: 'Справочник расходов',
			requiredLogin: true,
	        requiredRights: [[ 'pl_expense_guide_view' ]]
	    }
	},
	{
		name: 'ExpenseGuideSearchHistory',
		path: '/expenses-history',
		component: ExpenseGuideSearchHistory,
		meta: {
			title: prefixTitle + 'IFK Reports / Search History',
			mainMenu: false,
			userMenu: false,
			name: 'История поиска',
			requiredLogin: true,
	        requiredRights: [[ 'pl_expense_guide_edit' ]]
	    }
	},
	// Help
	{
		name: 'Help',
		path: '/help',
		component: Help,
		meta: {
			title: prefixTitle + 'IFK Reports / Help',
			mainMenu: true,
			userMenu: false,
			name: 'Справка',
			icon: 'help_outline',
			requiredLogin: true,
			requiredRights: [
				[ 'pr_view' ],
				[ 'drr_data_view' ],
				[ 'drr_input' ],
				[ 'pl_data_view' ],
				[ 'pl_input' ],
				[ 'pl_approve' ],
				[ 'pl_ho_approve' ],
				[ 'pl_owner_approve' ],
				[ 'pl_input_rooms' ],
				[ 'pl_input_fb' ],
				[ 'pl_input_hr' ],
				[ 'pl_input_utilities' ],
				[ 'pl_input_laundry' ],
				[ 'pl_input_sd' ],
				[ 'pl_bud_direct_input' ],
				[ 'pl_direct_input' ],
				[ 'user_mgmt' ],
				[ 'hotel_user_mgmt' ]
			],
			sections: [
				{
					href: '#pr',
					name: 'Заявки на расходы',
					requiredLogin: true,
					requiredRights: [[ 'pr_view' ]]
				},
				{
					href: '#drr-view',
					name: 'Просмотр отчетов DRR',
					requiredLogin: true,
					requiredRights: [[ 'drr_data_view' ]]
				},
				{
					href: '#pl-view',
					name: 'Просмотр отчетов PL',
					requiredLogin: true,
					requiredRights: [[ 'pl_data_view' ]]
				},
				{
					href: '#drr-input',
					name: 'Ввод данных DRR',
					requiredLogin: true,
					requiredRights: [[ 'drr_input' ]]
				},
				{
					href: '#pl-input',
					name: 'Ввод данных P&L',
					requiredLogin: true,
					requiredRights: [
						[ 'pl_input' ],
						[ 'pl_input_rooms' ],
						[ 'pl_input_fb' ],
						[ 'pl_input_hr' ],
						[ 'pl_input_utilities' ],
						[ 'pl_input_laundry' ],
						[ 'pl_input_sd' ],
						[ 'pl_bud_direct_input' ],
						[ 'pl_direct_input' ],
					]
				},
				{
					href: '#pl-forecast',
					name: 'Прогнозы P&L',
					requiredLogin: true,
					requiredRights: [[ 'pl_input' ]]
				},
				{
					href: '#pl-budgets',
					name: 'Бюджеты P&L',
					requiredLogin: true,
					requiredRights: [
						[ 'pl_input' ],
						[ 'pl_approve' ],
						[ 'pl_ho_approve' ],
						[ 'pl_owner_approve' ],
					]
				},
				{
					href: '#pl-codes',
					name: 'Коды ввода данных P&L',
					requiredLogin: true,
					requiredRights: [[ 'pl_input' ]]
				},
				{
					href: '#payroll',
					name: 'Распределение ФОТ по отделам',
					requiredLogin: true,
					requiredRights: [[ 'pl_input' ]]
				},
				{
					href: '#user-mgmt',
					name: 'Управление пользователями',
					requiredLogin: true,
					requiredRights: [[ 'user_mgmt' ], [ 'hotel_user_mgmt' ]]
				},
			],
		},
	},
	// Logs
	{
		name: 'Logs',
		path: '/logs',
		component: RouterThru,
		meta: {
			title: prefixTitle + 'IFK Reports / Logs',
			mainMenu: true,
			userMenu: false,
			name: 'Логи',
			icon: 'event_note',
			requiredLogin: true,
	        requiredRights: [[ 'logs_view' ]]
	    },
		children: [
			{
				name: 'LogsApi',
				path: 'api',
				component: LogsApi,
				meta: {
					title: prefixTitle + 'IFK Reports / Api logs',
					mainMenu: true,
					userMenu: false,
					name: 'API',
					requiredLogin: true,
			        requiredRights: [[ 'logs_view' ]]
			    }
			},
			{
				name: 'LogsAction',
				path: 'action',
				component: LogsAction,
				meta: {
					title: prefixTitle + 'IFK Reports / Action logs',
					mainMenu: true,
					userMenu: false,
					name: 'Действия',
					requiredLogin: true,
			        requiredRights: [[ 'logs_view' ]]
			    }
			},
			{
				name: 'LogsMail',
				path: 'mail',
				component: LogsMail,
				meta: {
					title: prefixTitle + 'IFK Reports / Mail logs',
					mainMenu: true,
					userMenu: false,
					name: 'Почта',
					requiredLogin: true,
			        requiredRights: [[ 'logs_view' ]]
			    }
			},
			{
				name: 'LogsReport',
				path: 'report',
				component: LogsReport,
				meta: {
					title: prefixTitle + 'IFK Reports / Report logs',
					mainMenu: true,
					userMenu: false,
					name: 'Отчеты',
					requiredLogin: true,
			        requiredRights: [[ 'logs_view' ]]
			    }
			},
			{
				name: 'LogsCron',
				path: 'cron',
				component: LogsCron,
				meta: {
					title: prefixTitle + 'IFK Reports / Cron logs',
					mainMenu: true,
					userMenu: false,
					name: 'Cron',
					requiredLogin: true,
			        requiredRights: [[ 'logs_view' ]]
			    }
			},
		]
	},
	// Login, Logout, SetPassword
	{
		name: 'Login',
		path: '/login',
		component: Login,
		meta: {
			title: prefixTitle + 'IFK Reports / Login',
			mainMenu: false,
			userMenu: false,
			requiredLogin: false,
			requiredRights: [[]]
		},
		beforeEnter: (to, from, next) => {
			if (store.getters.loggedIn) {
				// console.log('redirect')
				next(false)
			}
			else next()
		}
	},
	{
		name: 'Logout',
		path: '/logout',
		component: Logout,
		meta: {
			title: prefixTitle + 'Bye',
			mainMenu: false,
			userMenu: true,
			name: 'Выйти',
			requiredLogin: false,
			requiredRights: [[]]
		}
	},
	{
		name: 'SetPassword',
		path: '/set-password/:link',
		component: SetPassword,
		meta: {
			title: prefixTitle + 'IFK Reports / Welcome',
			mainMenu: false,
			userMenu: false,
			requiredLogin: false,
			requiredRights: [[]],
		},
		beforeEnter: (to, from, next) => {
			// console.log('router beforeEnter')
			if (store.getters.loggedIn) {
				// console.log('router redirect')
				next(false)
			}
			else next()
		}
	},
	// SurveyCollect
	{
		name: 'SurveyCollect',
		path: '/survey/:link',
		component: SurveyCollect,
		meta: {
			title: prefixTitle + 'IFK Reports / Опрос мнений',
			mainMenu: false,
			userMenu: false,
			requiredLogin: false,
			requiredRights: [[]]
		},
	},
	// AdminPanel, TestPanel
	{
		name: 'AdminPanel',
		path: '/admin',
		component: AdminPanel,
		meta: {
			title: prefixTitle + 'IFK Reports / Admin',
			mainMenu: true,
			userMenu: false,
			name: 'Панель администратора',
			// icon: 'developer_board',
			requiredLogin: true,
			requiredRights: [[ 'admin_panel_view' ]]
		}
	},
	{
		name: 'TestPanel',
		path: '/admin/test',
		component: TestPanel,
		meta: {
			title: prefixTitle + 'IFK Reports / Test',
			mainMenu: true,
			userMenu: false,
			name: 'Тестовая панель',
			// icon: 'free_breakfast',
			requiredLogin: true,
			requiredRights: [[ 'view_test' ]]
		}
	},
];

export const router = new VueRouter({
	routes
})

router.beforeEach((to, from, next) => {
	if (debug) console.log('router beforeEach')
	if (debug) console.log('-- to: ' + to.path)
	// if (debug) console.log(to)

	let youMayPass = !to.meta.requiredLogin || (store.getters.loggedIn && to.matched.every(route => {
		if (debug) console.log( '-- route: ' + route.path)
		return route.meta.requiredRights.some(rightArray => {
			if (debug) console.log('-- rightArray:')
			if (debug) console.log(rightArray)
			return rightArray.every(right => {
				if (debug) console.log('-- right: ' + right + ' ' + store.getters.userHasRight(right))
				return store.getters.userHasRight(right)
			})
		})
	}))

	if (debug) console.log('-- requiredLogin: ' + to.meta.requiredLogin)
	if (debug) console.log('-- youMayPass: ' + youMayPass)

	if (youMayPass) {
		if (to.meta.title !== undefined) {
			let title = to.meta.title
			for (let key in to.params) {
				let reg = new RegExp(':' + key, 'g')
				title = title.replace(reg, to.params[key])
			}
			document.title = title
		}
		if (debug) console.log('-- before next()')
		next()
	}
	else {
		if (debug) console.log('-- router redirect')

		if (store.getters.loggedIn) next(false)
		else {
			// console.log(to.path)
			store.dispatch('setPathBeforeLogin', to.path)
			next('/login')
		}
	}
})
